<template>
  <div class="flex items-center justify-between w-full py-4 text-dlubal-blue">
    <span
      data-test="title_place_holder"
      class="text-sm font-bold"
    >
      {{ $t('placeholder.chatTitle') }}
    </span>
    <div class="flex items-center gap-x-3">
      <button
        v-tooltip="{ content: t('controls.newConversation'), theme: 'tooltip-light' }"
        type="button"
        class="btn btn-secondary"
        @click="handleNewConversation"
      >
        <IconsReload class="w-4 h-4" />
      </button>

      <!-- TODO <button v-tooltip="{ content: t('controls.close'), theme: 'tooltip-light' }" type="button"
        class="btn btn-primary-dark">
        <IconsClose class="w-4 h-4 text-dlubal-blue" />
      </button> -->
    </div>
  </div>
</template>
<script setup lang="ts">
import { useConversationStore } from '@/stores/conversationStore'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const conversationStore = useConversationStore()
const { handleNewConversation } = conversationStore
</script>
